import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Pricing: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to learnmore page where pricing content exists
    navigate('/learnmore', { replace: true });
  }, [navigate]);

  return null;
};

export default Pricing; 